import { render, staticRenderFns } from "./audio-recorder.vue?vue&type=template&id=58133355&scoped=true&"
import script from "./audio-recorder.vue?vue&type=script&lang=js&"
export * from "./audio-recorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58133355",
  null
  
)

export default component.exports